import { atom } from "jotai";

type Device = {
    model: string;
    os: string;
    colorScheme: string;
}

export const deviceAtom = atom<Device>({
    model: '',
    os: '',
    colorScheme: '',
})